module.exports = __webpack_public_path__ + "img/report-7.3bb169b8.jpg";